export interface BusinessTravelerResponse {
  data: {
    loyalty_program: LoyaltyProgram;
  };
}

export interface BusinessTravelerPayload {
  query: string;
}

export interface LoyaltyProgram {
  loyaltyMemberAccount: LoyaltyMemberAccount;
}

export interface LoyaltyMemberAccount {
  loyaltyMemberEligibility: LoyaltyMemberEligibility;
}

export interface LoyaltyMemberEligibility {
  deltaBusinessTraveler: boolean | null;
  dbtPrompt: boolean | null;
}

export interface FeaturesFlag {
  flags: Flags;
  defaultURL: DefaultURL;
}

export interface Flags {
  enrollment: boolean;
  overview: boolean;
}

export interface DefaultURL {
  enrollment: string;
  overview: string;
}
